import { AlchemyDataLoader } from '@/components/patterns/AlchemyDataLoader';
import { cn } from '@/lib/utils';

export function AppLoadingFallback({ className }: { className?: string }) {
  return (
    <div className={cn('flex min-h-screen items-center justify-center bg-background', className)}>
      <AlchemyDataLoader
        variant="inline"
        forceActive
        hideTabLabels
        animationOnly
        animationLabel="Transmutando..."
        pendingTabIds={[]}
        completedTabs={[]}
      />
    </div>
  );
}
